module.exports = __webpack_public_path__ + "static/media/especial1.5c60fb7f.png";